var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBuildings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.68774 14.6673H3.34098C2.00428 14.6673 1.33594 14.0007 1.33594 12.6673V7.33398C1.33594 6.00065 2.00428 5.33398 3.34098 5.33398H6.6827V12.6673C6.6827 14.0007 7.35105 14.6673 8.68774 14.6673Z",
    stroke: "#7D899D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75508 2.66602C6.70161 2.86602 6.68157 3.08602 6.68157 3.33268V5.33268H3.33984V3.99935C3.33984 3.26602 3.94136 2.66602 4.67654 2.66602H6.75508Z",
    stroke: "#7D899D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.35547 5.33398V8.66732",
    stroke: "#7D899D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0312 5.33398V8.66732",
    stroke: "#7D899D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3605 11.334H10.0238C9.65622 11.334 9.35547 11.634 9.35547 12.0007V14.6673H12.0289V12.0007C12.0289 11.634 11.7281 11.334 11.3605 11.334Z",
    stroke: "#7D899D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.01172 8.66602V11.3327",
    stroke: "#7D899D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.68359 12.6673V3.33398C6.68359 2.00065 7.35194 1.33398 8.68863 1.33398H12.6987C14.0354 1.33398 14.7037 2.00065 14.7037 3.33398V12.6673C14.7037 14.0007 14.0354 14.6673 12.6987 14.6673H8.68863C7.35194 14.6673 6.68359 14.0007 6.68359 12.6673Z",
    stroke: "#7D899D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildings);
export default __webpack_public_path__ + "static/media/buildings.ad63df8e.svg";
export { ForwardRef as ReactComponent };